import Icon from "@client/controls/Icon/component";
import SelectStatic, { SelectItem } from "@client/controls/Inputs/Select/Static/component";
import { IconType } from "@client/types";
import { ContentAlign } from "@common/hocs/withDropdown/lib";
import { useI18n } from "@common/hooks/i18n";
import React from "react";

type ActionsProps = {
  onDeleteClick: () => void;
  onUpdateClick: () => void;
};
const Actions = (props: ActionsProps) => {
  const i18n = useI18n();

  return (
    <SelectStatic align={ContentAlign.BottomRight} title={i18n.actions} theme="borderless">
      <SelectItem onClick={props.onUpdateClick}>
        <Icon iconClassName={IconType.Cog} />
        {i18n.update}
      </SelectItem>

      <SelectItem onClick={props.onDeleteClick}>
        <Icon iconClassName={IconType.Delete} />
        {i18n.delete}
      </SelectItem>
    </SelectStatic>
  );
};
export default Actions;
